import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'supportTicket.header.title' }),
    description: translate({ id: 'supportTicket.header.description' }),
  }))

  return api
}
